module.exports = __webpack_public_path__ + "static/media/Icon simple-email.0f5cf5b1.svg";